import React, { useEffect, useState } from "react";
import { fetchActivePlans } from "../../services/planService";
import { fetchActiveSpeakers } from "../../services/adminSpeakerServices";
import {
 addSessionToDay,
 updateSession,
} from "../../services/adminTimeTableServices";
import {
 extractLocalTime,
 buildLocalDateTime,
} from "../../../utils/dateTimeUtils";

const inputStyle = {
 width: "100%",
 padding: "8px",
 marginBottom: "12px",
};

const SessionModal = ({ dayId, dayDate, session, onClose, reload }) => {
 const [plans, setPlans] = useState([]);
 const [speakers, setSpeakers] = useState([]);

 const [form, setForm] = useState({
 topic: "",
 level: "",
 planId: "",
 totalSlots: 1,
 speakerId: "",
 });

 const [startClock, setStartClock] = useState("");
 const [endClock, setEndClock] = useState("");

 /* ===============================
 Fetch plans & speakers
 =============================== */
 useEffect(() => {
 fetchActivePlans().then((res) => setPlans(res.data || []));
 fetchActiveSpeakers().then((res) => setSpeakers(res.data || []));

 if (session) {
 setForm({
 topic: session.topic,
 level: session.level,
 planId: session.planId,
 totalSlots: session.totalSlots,
 speakerId: session.speakerId ?? "",
 });

 const localStart = extractLocalTime(session.startTime);
 const localEnd = extractLocalTime(session.endTime);

 setStartClock(localStart);
 setEndClock(localEnd);
 }
 }, [session]);

 /* ===============================
 Submit
 =============================== */
 const handleSubmit = async () => {
 const startDateTime = buildLocalDateTime(dayDate, startClock);
 const endDateTime = buildLocalDateTime(dayDate, endClock);

 const payload = {
 ...form,
 speakerId: form.speakerId || null, // allow optional
 startTime: startDateTime,
 endTime: endDateTime,
 };


 try {
 if (session) {
 await updateSession(session.id, payload);
 } else {
 await addSessionToDay(dayId, payload);
 }

 reload();
 onClose();
 } catch (err) {
 alert(err.response?.data?.message || "Validation error");
 }
 };

 return (
 <div
 style={{
 position: "fixed",
 inset: 0,
 background: "rgba(0,0,0,0.5)",
 display: "flex",
 justifyContent: "center",
 alignItems: "center",
 zIndex: 1000,
 }}
 onClick={onClose}
 >
 <div
 style={{
 background: "#fff",
 padding: "20px",
 borderRadius: "8px",
 width: "400px",
 }}
 onClick={(e) => e.stopPropagation()}
 >
 <h3>{session ? "Edit Session" : "Add Session"}</h3>

 {/* Date */}
 <input style={{ ...inputStyle, background: "#eee" }} value={dayDate} disabled />

 {/* Topic */}
 <input
 style={inputStyle}
 placeholder="Topic"
 value={form.topic}
 onChange={(e) => setForm({ ...form, topic: e.target.value })}
 />

 {/* Level */}
 <select
 style={inputStyle}
 value={form.level}
 onChange={(e) => setForm({ ...form, level: e.target.value })}
 >
 <option value="">Select Level</option>
 <option value="BEGINNER">BEGINNER</option>
 <option value="INTERMEDIATE">INTERMEDIATE</option>
 <option value="ADVANCED">ADVANCED</option>
 </select>

 {/* Time */}
 <input
 type="time"
 style={inputStyle}
 value={startClock}
 onChange={(e) => {
 const start = e.target.value;
 setStartClock(start);

 const [h, m] = start.split(":").map(Number);
 const end = new Date(0, 0, 0, h, m + 30);

 const endVal = `${String(end.getHours()).padStart(2, "0")}:${String(
 end.getMinutes()
 ).padStart(2, "0")}`;

 setEndClock(endVal);
 }}
 />

 <input
 type="time"
 style={inputStyle}
 value={endClock}
 onChange={(e) => {
 setEndClock(e.target.value);
 }}
 />

 {/* Plan */}
 <select
 style={inputStyle}
 value={form.planId}
 onChange={(e) => setForm({ ...form, planId: Number(e.target.value) })}
 >
 <option value="">Select Plan</option>
 {plans.map((p) => (
 <option key={p.id} value={p.id}>
 {p.planName} ({p.planType})
 </option>
 ))}
 </select>

 {/* Slots */}
 <input
 type="number"
 min={1}
 style={inputStyle}
 value={form.totalSlots}
 onChange={(e) =>
 setForm({ ...form, totalSlots: Number(e.target.value) })
 }
 />

 {/* ✅ Speaker */}
 <select
 style={inputStyle}
 value={form.speakerId}
 onChange={(e) =>
 setForm({
 ...form,
 speakerId: e.target.value ? Number(e.target.value) : "",
 })
 }
 >
 <option value="">Select Speaker</option>
 {speakers.map((s) => (
 <option key={s.id} value={s.id}>
 {s.name}
 </option>
 ))}
 </select>

 {/* Actions */}
 <div style={{ textAlign: "right" }}>
 <button onClick={handleSubmit} style={{ marginRight: "10px" }}>
 Save
 </button>
 <button onClick={onClose}>Cancel</button>
 </div>
 </div>
 </div>
 );
};

export default SessionModal;
